import { BrowserRouter as Router } from 'react-router-dom';

import Routes from './routes';

function App(): JSX.Element {
  document.title = `Homeprotect Customer Portal`;
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="App">
        <Routes />
      </div>
    </Router>
  );
}

export default App;
